module.exports = __webpack_public_path__ + "img/2_226.d72bc2b1.png";